/*
  Clasp & Bloom 1.5.0/1.6.0 – behaviour for the design feedback (cards' quick 'Add to bag', cart count badge,
  announcement pause).
  The add-to-bag form is only rendered when purchasing is open (snippets/cb-card-add.liquid); this script never adds
  anything for a closed or disabled control.
*/
(function () {
  var strings = window.cbStrings || {};

  function setStatus(root, text, persist) {
    var status = root.querySelector('.cb-card-add__status');
    if (!status) return;
    status.textContent = text || '';
    clearTimeout(status._cbTimer);
    if (text && !persist) status._cbTimer = setTimeout(function () { status.textContent = ''; }, 3500);
  }

  function refreshCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = (cart.items || []).reduce(function (total, item) { return total + item.quantity; }, 0);
        if (typeof window.updateCartCount === 'function') window.updateCartCount(count);
        document.querySelectorAll('.header-cart-count').forEach(function (el) { el.classList.toggle('is-empty', count === 0); });
        if (typeof window.fetchCart === 'function') window.fetchCart();
        return cart;
      });
  }

  window.cbRefreshCart = refreshCart; /* 1.19.8: used by the Bundle & Save picker */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-cb-card-add-form]');
    if (!form) return;
    event.preventDefault();
    var root = form.closest('[data-cb-card-add]');
    var button = form.querySelector('button[type="submit"]');
    if (!root || !button || button.getAttribute('aria-busy') === 'true') return; // one request at a time
    var label = button.querySelector('[data-cb-label]');
    var original = label ? label.textContent : '';
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    root.classList.add('is-active');
    if (label) label.textContent = strings.adding || 'Adding…';
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || strings.error);
          return data;
        });
      })
      .then(function () {
        setStatus(root, strings.added || 'Added to cart');
        return refreshCart().then(function () {
          if (typeof window.showCartDrawer === 'function' && window.routes && window.routes.cart_type === 'drawer') window.showCartDrawer();
        });
      })
      .catch(function (error) {
        setStatus(root, (error && error.message) || strings.error || 'This bag could not be added.', true);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label) label.textContent = original;
        setTimeout(function () { root.classList.remove('is-active'); }, 1500);
      });
  });

  /* closed or sold out: a short note instead of an action (also on touch screens, where there is no hover) */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.cb-card-add__btn.is-disabled');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var root = button.closest('[data-cb-card-add]');
    if (root) setStatus(root, button.getAttribute('data-cb-card-message'));
  });

  /* product page on phones: thumbnails below the main photo (snippet product-media-gallery switches the direction);
     Bera's horizontal thumbnail slider shows two large thumbnails on phones, we show four small ones */
  function compactThumbs() {
    document.querySelectorAll('wdt-main-media.cb-thumbs-below .product-thumbnails').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || sw.cbCompact) return;
      sw.cbCompact = true;
      sw.params.breakpoints = null;
      sw.params.slidesPerView = 4;
      sw.params.spaceBetween = 8;
      sw.update();
    });
  }
  document.addEventListener('DOMContentLoaded', compactThumbs);
  window.addEventListener('load', compactThumbs);
  setTimeout(compactThumbs, 1200);

  /* product recommendations: when Shopify returns none (a new store has no data yet), show the fallback row that the
     section rendered with the page (other bags from the same category, start collection only) */
  function initRecoFallback(tpl) {
    var section = tpl.closest('.shopify-section');
    var el = section && section.querySelector('product-recommendations');
    if (!el) return;
    var done = false;
    var varied = tpl.hasAttribute('data-cb-reco-varied');
    function useFallback() {
      if (el.querySelector('.recommendation-items') && (!varied || el.classList.contains('cb-reco-fallback'))) return;
      el.innerHTML = tpl.innerHTML;
      section.classList.remove('d-none');
      el.classList.add('product-recommendations--loaded', 'cb-reco-fallback');
      if (typeof el.initSlider === 'function') el.initSlider();
      if (typeof el.initQuickViewButtons === 'function') el.initQuickViewButtons();
      done = true;
    }
    // Bera's script replaces the content when its request returns; react to that, and fall back after a timeout
    new MutationObserver(function () {
      if (!el.querySelector('.recommendation-items')) setTimeout(useFallback, 50);
    }).observe(el, { childList: true });
    if (varied) useFallback(); // 1.18.0: the varied range is shown straight away
    setTimeout(function () { if (!done) useFallback(); }, 4000);
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('template[data-cb-reco-fallback]').forEach(initRecoFallback);
  });

  /* announcement bar: pause/play button for the scrolling messages (Clasp & Bloom 1.6.0) */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cb-ann-toggle]');
    if (!button) return;
    var bar = button.closest('[data-cb-ann]');
    if (!bar) return;
    var paused = !bar.classList.contains('is-paused');
    bar.classList.toggle('is-paused', paused);
    button.setAttribute('aria-label', button.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
  });

  /* cart badge: hidden while the bag is empty (the count stays available to screen readers) */
  function syncBadge(el) {
    var visible = el.querySelector('[aria-hidden="true"]');
    var count = parseInt((visible || el).textContent, 10) || 0;
    el.classList.toggle('is-empty', count === 0);
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header-cart-count').forEach(function (el) {
      syncBadge(el);
      new MutationObserver(function () { syncBadge(el); }).observe(el, { childList: true, subtree: true, characterData: true });
    });
  });
})();

/* Clasp & Bloom 1.12.0: Bundle & Save progress (snippet cb-bundle-progress).
   Same rules as the Liquid markup:
   - progress counts only bags whose product id is in data-eligible (the participating collection);
   - "applied" and the saving come only from Shopify's own line discount allocations of an automatic discount whose
     title starts with data-prefix; the tier shown is that discount's own percentage. cart.total_discount is never used,
     so another discount is never presented as Bundle & Save. It never calculates or applies a discount. */
(function () {
  function tiersOf(el) {
    return (el.getAttribute('data-tiers') || '').split(',').map(function (t) {
      var p = t.split(':');
      return { min: parseInt(p[0], 10), pct: String(p[1] || '').trim() };
    }).filter(function (t) { return t.min > 0 && parseFloat(t.pct) > 0; }).sort(function (a, b) { return a.min - b.min; });
  }
  function money(cents, format) {
    var v = (cents / 100).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
      if (kind === 'amount_no_decimals') return whole;
      if (kind === 'amount_with_comma_separator') return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
      return whole + '.' + v[1];
    });
    var tmp = document.createElement('textarea');
    tmp.innerHTML = out;
    return tmp.value;
  }
  function bundleState(el, cart) {
    var ids = (el.getAttribute('data-eligible') || '').split(',').filter(Boolean);
    var prefix = (el.getAttribute('data-prefix') || '').trim();
    var state = { count: 0, saving: 0, pct: 0 };
    (cart.items || []).forEach(function (it) {
      if (ids.indexOf(String(it.product_id)) > -1) state.count += it.quantity;
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var app = al.discount_application || {};
        if (prefix && app.type !== 'discount_code' && app.type !== 'manual' && String(app.title || '').indexOf(prefix) === 0) {
          state.saving += parseInt(al.amount, 10) || 0;
          if (app.value_type === 'percentage') state.pct = Math.round(parseFloat(app.value));
        }
      });
    });
    return state;
  }
  function render(el, st) {
    var i18n = {};
    var src = el.querySelector('[data-cb-bundle-i18n]');
    try { i18n = JSON.parse(src.textContent); } catch (e) { return; }
    /* Shopify's 't' filter returns HTML-escaped text ('Bundle &amp; Save'); textContent needs plain text. */
    var dec = document.createElement('textarea');
    Object.keys(i18n).forEach(function (k) { if (typeof i18n[k] === 'string' && k !== 'money_format') { dec.innerHTML = i18n[k]; i18n[k] = dec.value; } });
    var tiers = tiersOf(el);
    if (!tiers.length) return;
    var count = st.count, applied = st.saving > 0 && st.pct > 0;
    var next = null;
    tiers.forEach(function (t) { if (count < t.min && !next) next = t; });
    var parts = [];
    if (applied) parts.push(i18n.applied.replace('__P__', st.pct));
    if (next) {
      var missing = next.min - count;
      parts.push((missing === 1 ? i18n.add_one : i18n.add_other).replace('__M__', missing).replace('__P__', next.pct));
    } else if (applied) {
      parts.push(i18n.best);
    }
    el.querySelector('[data-cb-bundle-text]').textContent = count === 0 || !parts.length ? i18n.empty : parts.join(' ');
    var steps = el.querySelector('[data-cb-bundle-steps]');
    steps.innerHTML = '';
    tiers.forEach(function (t, i) {
      var li = document.createElement('li');
      var last = i === tiers.length - 1;
      li.className = 'cb-bundle-progress__step' + (count >= t.min ? ' is-reached' : '');
      var c = document.createElement('span');
      c.textContent = (last ? i18n.step_plus : i18n.step).replace('__C__', t.min);
      var o = document.createElement('strong');
      o.textContent = i18n.off.replace('__P__', t.pct);
      li.appendChild(c);
      li.appendChild(o);
      if (count >= t.min) {
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = ' (' + i18n.reached + ')';
        li.appendChild(sr);
      }
      steps.appendChild(li);
    });
    var sav = el.querySelector('[data-cb-bundle-saving]');
    if (applied) { sav.textContent = i18n.saving.replace('__A__', money(st.saving, i18n.money_format)); sav.hidden = false; } else { sav.textContent = ''; sav.hidden = true; }
    el.classList.toggle('is-empty', count === 0);
  }
  function renderAll(cart) {
    document.querySelectorAll('[data-cb-bundle-progress]').forEach(function (el) { render(el, bundleState(el, cart)); });
  }
  window.cbBundleState = bundleState;
  var timer = null;
  var refreshSeq = 0;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!document.querySelector('[data-cb-bundle-progress]')) return;
      var root = (window.routes && window.routes.cart_url) || '/cart';
      var mine = ++refreshSeq; /* 1.19.3: a slower, older answer never overwrites a newer one */
      window.__cbOrigFetch(root + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); }).then(function (cart) { if (mine === refreshSeq) renderAll(cart); }).catch(function () {});
    }, 150);
  }
  if (window.fetch && !window.__cbOrigFetch) {
    window.__cbOrigFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = window.__cbOrigFetch(input, init);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { refresh(); }, function () {});
      }
      return p;
    };
  }
  /* The initial markup is rendered by Liquid with the same rules; JS only re-renders after cart changes. */
})();


/*
  Clasp & Bloom 1.13.0 – scrolling service bar speed, mega menu category images, hero slideshow controls and the
  "See how to style it" pairs. Everything also works after the theme editor re-renders a section.
*/
(function () {
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* --- service bar: the same speed (px per second) on every screen width --- */
  function setMarqueeSpeed(bar) {
    var track = bar.querySelector('.cb-marquee__track');
    if (!track) return;
    var speed = parseFloat(bar.getAttribute('data-speed')) || 35;
    var distance = track.scrollWidth / 2;
    if (distance > 0) bar.style.setProperty('--cb-ann-duration', (distance / speed).toFixed(1) + 's');
  }
  function initMarquees(scope) {
    (scope || document).querySelectorAll('[data-cb-marquee]').forEach(setMarqueeSpeed);
  }
  document.addEventListener('DOMContentLoaded', function () { initMarquees(); });
  window.addEventListener('load', function () { initMarquees(); });
  var marqueeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(initMarquees, 200);
  });

  /* --- mega menu: hovering or focusing a category link shows that category's two images --- */
  function showMegaSet(item, key) {
    item.querySelectorAll('[data-cb-mega-sets]').forEach(function (box) {
      var target = box.querySelector('[data-cb-mega-set="' + key + '"]') ? key : '0';
      box.querySelectorAll('[data-cb-mega-set]').forEach(function (card) {
        card.classList.toggle('is-active', card.getAttribute('data-cb-mega-set') === target);
      });
    });
  }
  function onMegaKey(event) {
    var link = event.target.closest && event.target.closest('[data-cb-mega-key]');
    if (!link) return;
    var item = link.closest('.has-mega-menu');
    if (item) showMegaSet(item, link.getAttribute('data-cb-mega-key'));
  }
  function loadMegaImages(event) {
    var item = event.target.closest && event.target.closest('.has-mega-menu');
    if (!item || item.cbMegaLoaded) return;
    item.cbMegaLoaded = true;
    item.querySelectorAll('[data-cb-mega-set] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  function onMegaLeave(event) {
    var item = event.target.closest && event.target.closest('.has-mega-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    // back to the default images once the menu has closed (after its fade), never while it is still open
    setTimeout(function () {
      if (!item.matches(':hover') && !item.contains(document.activeElement)) showMegaSet(item, '0');
    }, 350);
  }
  document.addEventListener('mouseover', onMegaKey);
  document.addEventListener('focusin', onMegaKey);
  document.addEventListener('mouseover', loadMegaImages);
  document.addEventListener('focusin', loadMegaImages);
  document.addEventListener('mouseout', onMegaLeave);
  document.addEventListener('focusout', onMegaLeave);

  /* --- hero slideshow (wdt-slideshow, Swiper from theme.js) --- */
  function setHeroButton(button, paused) {
    if (!button) return;
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    var pauseIcon = button.querySelector('[data-ns-icon-pause]');
    var playIcon = button.querySelector('[data-ns-icon-play]');
    if (pauseIcon) pauseIcon.hidden = paused;
    if (playIcon) playIcon.hidden = !paused;
  }
  function initHero(host, tries) {
    if (host.cbHero) return;
    var swiper = host.swiperInstance;
    if (!swiper) {
      if ((tries || 0) < 120) setTimeout(function () { initHero(host, (tries || 0) + 1); }, 50);
      return;
    }
    host.cbHero = true;
    var button = host.querySelector('[data-cb-hero-toggle]');
    var state = { userPaused: false, focusPaused: false };
    function syncSlides() {
      Array.prototype.forEach.call(swiper.slides, function (slide, index) {
        var active = index === swiper.activeIndex;
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      // the active dot carries aria-current (Swiper only marks it with a class)
      host.querySelectorAll('.swiper-pagination-bullet').forEach(function (dot) {
        if (dot.classList.contains('swiper-pagination-bullet-active')) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function run() {
      if (!swiper.autoplay || !swiper.params.autoplay) return;
      if (state.userPaused || state.focusPaused) swiper.autoplay.stop();
      else if (!swiper.autoplay.running) swiper.autoplay.start();
    }
    swiper.on('slideChange', syncSlides);
    swiper.on('slideChangeTransitionEnd', syncSlides);
    swiper.on('paginationUpdate', syncSlides);
    syncSlides();
    if (reduceMotion.matches) {
      swiper.params.speed = 0;
      state.userPaused = true;
      setHeroButton(button, true);
    }
    run();
    if (button) {
      button.addEventListener('click', function () {
        state.userPaused = !state.userPaused;
        setHeroButton(button, state.userPaused);
        run();
      });
    }
    // pause while a link, dot or button in the slideshow has keyboard focus
    host.addEventListener('focusin', function (event) {
      var t = event.target;
      if (t === button) return;
      if (t.matches && t.matches(':focus-visible')) { state.focusPaused = true; run(); }
    });
    host.addEventListener('focusout', function (event) {
      if (host.contains(event.relatedTarget)) return;
      state.focusPaused = false;
      run();
    });
  }
  function setHeroOffset() {
    var host = document.querySelector('wdt-slideshow');
    if (!host) return;
    var top = host.getBoundingClientRect().top + window.scrollY;
    if (top > 0) document.documentElement.style.setProperty('--cb-hero-offset', Math.round(top) + 'px');
    // left edge of the hero text, so the dots line up under it
    var text = host.querySelector('.banner-overlay.d-md-flex .content-block');
    if (text && text.offsetWidth) {
      var left = text.getBoundingClientRect().left - host.getBoundingClientRect().left;
      host.style.setProperty('--cb-hero-dots-left', Math.round(left) + 'px');
    }
  }
  function initHeroes(scope) {
    setHeroOffset();
    (scope || document).querySelectorAll('wdt-slideshow').forEach(function (host) { initHero(host, 0); });
  }
  var heroResize;
  window.addEventListener('resize', function () {
    clearTimeout(heroResize);
    heroResize = setTimeout(setHeroOffset, 200);
  });
  document.addEventListener('DOMContentLoaded', function () { initHeroes(); });
  window.addEventListener('load', function () { initHeroes(); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('wdt-slideshow').forEach(function (host) {
      if (host.swiperInstance && host.swiperInstance.destroy) host.swiperInstance.destroy(true, false);
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    initHeroes(event.target);
    initMarquees(event.target);
  });

  /* --- See how to style it: one slide = bag photo, name, price and worn photo of the same product and colour --- */
  function lookGo(root, step) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cb-look-slide]'));
    if (slides.length < 2) return;
    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var next = (current + step + slides.length) % slides.length;
    var focused = document.activeElement;
    var refocus = null;
    if (focused && slides[current].contains(focused)) {
      refocus = focused.hasAttribute('data-cb-look-prev') ? '[data-cb-look-prev]' : focused.hasAttribute('data-cb-look-next') ? '[data-cb-look-next]' : null;
    }
    slides.forEach(function (slide, index) {
      var active = index === next;
      slide.classList.toggle('is-active', active);
      slide.inert = !active;
      if (active) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });
    if (refocus) {
      var target = slides[next].querySelector(refocus);
      if (target) target.focus({ preventScroll: true });
    }
    var live = root.querySelector('[data-cb-look-live]');
    if (live) live.textContent = slides[next].getAttribute('data-announce') || '';
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cb-look-prev], [data-cb-look-next]');
    if (!button) return;
    var root = button.closest('[data-cb-look]');
    if (root) lookGo(root, button.hasAttribute('data-cb-look-prev') ? -1 : 1);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var root = event.target.closest && event.target.closest('[data-cb-look]');
    if (!root) return;
    event.preventDefault();
    lookGo(root, event.key === 'ArrowLeft' ? -1 : 1);
  });
  // swipe on touch screens
  var touch = null;
  document.addEventListener('touchstart', function (event) {
    var root = event.target.closest && event.target.closest('[data-cb-look]');
    touch = root && event.touches.length === 1 ? { root: root, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (!touch) return;
    var dx = event.changedTouches[0].clientX - touch.x;
    var dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) lookGo(touch.root, dx < 0 ? 1 : -1);
    touch = null;
  }, { passive: true });
  // load all pair images once the section comes near, so a switch never shows an empty frame
  function preloadLooks() {
    var roots = document.querySelectorAll('[data-cb-look]');
    if (!roots.length) return;
    var load = function (root) { root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; }); };
    if (!('IntersectionObserver' in window)) { roots.forEach(load); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '600px 0px' });
    roots.forEach(function (root) { observer.observe(root); });
  }
  document.addEventListener('DOMContentLoaded', preloadLooks);
  document.addEventListener('shopify:section:load', preloadLooks);
})();

/* Clasp & Bloom 1.16.0: the fixed buy bar (#sticky-atc-bar) is hidden while the footer is on screen, on desktop and on
   phones, so it never covers footer links such as Cookie preferences. Theme element only; Shopify's preview bar and
   browser extensions are not touched. */
(function () {
  var frame = null;
  function check() {
    frame = null;
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    var near = !!footer && footer.getBoundingClientRect().top < window.innerHeight;
    bar.classList.toggle('cb-near-footer', near);
  }
  function schedule() { if (frame === null) frame = window.requestAnimationFrame(check); }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('DOMContentLoaded', check);
  window.addEventListener('load', check);

  /* 1.19.4: (a) --cb-sticky-h tells the back-to-top button how high the visible buy bar is; (b) the bar waits while Shopify's
     cookie banner is on screen. */
  function sync() {
    var root = document.documentElement;
    var bar = document.getElementById('sticky-atc-bar');
    var banner = document.getElementById('shopify-pc__banner');
    root.classList.toggle('cb-consent-open', !!(banner && banner.getClientRects().length));
    var shown = !!bar && bar.classList.contains('show') && !bar.classList.contains('cb-near-footer') && bar.style.display !== 'none' && !root.classList.contains('cb-consent-open');
    root.classList.toggle('cb-sticky-on', shown);
    if (shown) root.style.setProperty('--cb-sticky-h', Math.round(bar.getBoundingClientRect().height) + 'px');
  }
  window.setInterval(sync, 300);
  document.addEventListener('DOMContentLoaded', sync);
})();


/*
  Clasp & Bloom 1.19.3 – one cart controller for the cart drawer and the cart page (window.cbCart).
  Why: two older scripts changed quantities independently. A typed value waited 400 ms and was lost when the page was
  left in that time, an older answer could be drawn over a newer one, and the cart page only patched the numbers it knew
  about, so a struck-through price and the "Bundle & Save" label of the previous quantity stayed on screen.
  Now:
  - every change is a wish per line (always the latest value); wishes are sent one after another;
  - + and − count from the latest wish, so quick clicks add up; typing is committed on Enter, on leaving the field
    and (for + and −) after a short pause;
  - empty or invalid input is refused with a message and the field returns to the saved quantity;
  - a wish still waiting is sent before checkout opens and when the page is left (keepalive);
  - after the last wish is answered, the drawer is redrawn from Shopify's cart and the cart page is replaced by
    the cart page Shopify renders, so quantity, prices, discount label and amount, subtotal and bundle progress
    can never disagree. A response is never drawn when a newer change is waiting.
*/
(function () {
  if (window.cbCart) return;
  var DEBOUNCE = 250;
  var desired = {};
  var timers = {};
  var serverQty = {};
  var sent = {};
  var notes = {};
  var queue = Promise.resolve();
  var busy = 0;
  var lastCart = null;
  var renderSeq = 0;
  var cartRoot = function () { return (window.routes && window.routes.cart_url) || '/cart'; };
  var changeUrl = function () { return ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js'; };
  var T = {
    invalid: 'Please enter a whole number, 0 or higher.',
    error: (window.cartStrings && window.cartStrings.error) || 'The cart could not be updated. Please try again.',
    low: (window.cartStrings && window.cartStrings.lowQuantity) || 'Only [quantity] left in stock',
    updated: 'Cart updated.'
  };

  /* Shopify's line key changes when the discount of the line changes (e.g. 6 -> 1 bags); the variant id does not. */
  function V(key) { return String(key).split(':')[0]; }
  function pending() { return Object.keys(desired).length > 0 || Object.keys(timers).length > 0; }
  function isBusy() { return pending() || busy > 0; }

  var BTN = '.increment, .decrement, .increment-btn, .decrement-btn, .cart-remove-button, .main-cart-remove-button';
  var INPUT = 'input.cart-item-quantity, drawer-quantity-editor input[name="quantity"]';
  function inCart(el) { return !!(el && el.closest && el.closest('.main-card, #cartOffCanvas')); }
  function keyOf(el) {
    if (!el) return null;
    if (el.dataset && el.dataset.cbKey) return el.dataset.cbKey;
    var ed = el.closest && el.closest('drawer-quantity-editor');
    if (ed && ed.dataset.line) return ed.dataset.line;
    if (el.dataset && el.dataset.line && el.closest && el.closest('#cartOffCanvas')) return el.dataset.line;
    var row = el.closest && el.closest('[data-cb-key]');
    return row ? row.dataset.cbKey : null;
  }
  function inputsFor(key) {
    return [].filter.call(document.querySelectorAll(INPUT), function (i) { var k = keyOf(i); return k && V(k) === key; });
  }
  function rowsFor(key) {
    var rows = [];
    [].forEach.call(document.querySelectorAll('[id^="CartItem-' + key + ':"], [id^="cartItems-"][data-cb-key^="' + key + ':"]'), function (r) { rows.push(r); });
    return rows;
  }
  function rowFor(key) { return rowsFor(key)[0] || null; }
  function currentQty(key) {
    key = V(key);
    if (key in desired) return desired[key];
    if (key in sent) return sent[key];
    if (key in serverQty) return serverQty[key];
    var i = inputsFor(key)[0];
    return i ? (parseInt(i.defaultValue, 10) || parseInt(i.value, 10) || 0) : 0;
  }
  function setInputs(key, qty) {
    key = V(key);
    inputsFor(key).forEach(function (i) { i.value = qty; });
    document.querySelectorAll('[data-cb-key^="' + key + ':"].increment, [data-line^="' + key + ':"].increment-btn').forEach(function (b) { b.setAttribute('data-quantity', qty + 1); });
    document.querySelectorAll('[data-cb-key^="' + key + ':"].decrement, [data-line^="' + key + ':"].decrement-btn').forEach(function (b) { b.setAttribute('data-quantity', Math.max(0, qty - 1)); });
  }
  function note(key, text) {
    key = V(key);
    if (text) notes[key] = text; else delete notes[key];
    rowsFor(key).forEach(function (row) {
      var box = row.querySelector('.cart-message') || row.querySelector('.drawer-cart-message');
      if (!box) return;
      box.classList.toggle('d-none', !text);
      if (text) { box.setAttribute('role', 'alert'); box.innerHTML = '<span class="pro_error"></span>'; box.firstChild.textContent = text; }
      else { box.innerHTML = ''; }
    });
  }
  function mark(key, on) {
    key = V(key);
    rowsFor(key).forEach(function (row) {
      row.classList.toggle('is-updating', on);
      if (on) row.setAttribute('aria-busy', 'true'); else row.removeAttribute('aria-busy');
    });
  }
  function syncServer(cart) {
    serverQty = {};
    (cart.items || []).forEach(function (it) { serverQty[V(it.key)] = it.quantity; });
  }
  function badge(count) {
    var one = (window.cartStrings && window.cartStrings.itemOne) || '1 item';
    var other = (window.cartStrings && window.cartStrings.itemOther) || '[count] items';
    document.querySelectorAll('.header-cart-count').forEach(function (el) {
      var visible = el.querySelector('[aria-hidden="true"]');
      var hidden = el.querySelector('.visually-hidden');
      if (visible) visible.textContent = count;
      if (hidden) hidden.textContent = count === 1 ? one : other.replace('[count]', count);
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function commit(key, qty, immediate) {
    if (!key || isNaN(qty)) return queue;
    key = V(key);
    qty = Math.max(0, qty);
    note(key, '');
    if (qty === currentQty(key)) { setInputs(key, qty); if (immediate && (key in timers)) send(key); return queue; } /* same wish: never send twice */
    desired[key] = qty;
    setInputs(key, qty);
    mark(key, true);
    clearTimeout(timers[key]);
    if (immediate) { delete timers[key]; return send(key); }
    timers[key] = setTimeout(function () { send(key); }, DEBOUNCE);
    return queue;
  }

  function send(key) {
    clearTimeout(timers[key]); delete timers[key];
    busy++;
    queue = queue.then(function () {
      if (!(key in desired)) return;
      var qty = desired[key]; delete desired[key]; sent[key] = qty;
      return fetch(changeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || !res.data || !res.data.items) throw new Error((res.data && (res.data.description || res.data.message)) || T.error);
          lastCart = res.data;
          delete sent[key];
          syncServer(res.data);
          var it = res.data.items.filter(function (i) { return V(i.key) === key; })[0];
          if (qty > 0 && it && it.quantity < qty) note(key, T.low.replace('[quantity]', it.quantity));
        })
        .catch(function (err) { lastCart = null; delete sent[key]; mark(key, false); note(key, err && err.message ? err.message : T.error); setInputs(key, key in serverQty ? serverQty[key] : currentQty(key)); });
    }).then(function () { busy--; settle(); });
    return queue;
  }

  function flush() {
    Object.keys(timers).forEach(function (k) { send(k); });
    Object.keys(desired).forEach(function (k) { if (!(k in timers)) send(k); });
    return queue;
  }

  function getCart() {
    if (lastCart) { var c = lastCart; lastCart = null; return Promise.resolve(c); }
    return window.fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function settle() {
    if (pending() || busy > 0) return;
    var mine = ++renderSeq;
    getCart().then(function (cart) {
      if (mine !== renderSeq || pending() || busy > 0) return;
      render(cart, mine);
    }).catch(function () {});
  }

  /* 1.19.4: the cart page is never swapped between pointerdown and pointerup: a click whose first half hit the old element
     and whose second half hit the new one is not delivered as a click. */
  var pressed = false;
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (n) { document.addEventListener(n, function () { pressed = true; }, true); });
  ['pointerup', 'pointercancel', 'mouseup', 'touchend', 'touchcancel'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(function () { pressed = false; }, 0); }, true); });
  function whenReleased() {
    if (!pressed) return Promise.resolve();
    return new Promise(function (resolve) {
      var tries = 0;
      (function wait() { if (!pressed || ++tries > 40) resolve(); else setTimeout(wait, 50); })();
    });
  }

  function render(cart, mine) {
    syncServer(cart);
    badge(cart.item_count);
    var page = document.querySelector('.main-card .container');
    var active = document.activeElement;
    var focusKey = active && active.matches && active.matches(INPUT + ', ' + BTN) ? keyOf(active) : null;
    var focusClass = active && active.matches && active.matches(BTN) ? (active.className.split(' ').filter(function (c) { return /increment|decrement/.test(c); })[0] || '') : '';
    var done = Promise.resolve();
    if (page && /(^|\/)cart\/?$/.test(location.pathname.replace(/\/+$/, '') || '/')) {
      done = window.fetch(cartRoot() + '?_cb=' + Date.now(), { headers: { Accept: 'text/html' }, cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.main-card .container');
          if (!fresh) { location.reload(); return; }
          return whenReleased().then(function () {
            if (mine !== renderSeq || pending() || busy > 0) return;
            page.innerHTML = fresh.innerHTML;
          });
        });
    }
    var drawer = document.getElementById('cart-items-list') && typeof window.fetchCart === 'function' ? window.fetchCart() : null;
    return Promise.all([done, drawer]).then(function () {
      Object.keys(notes).forEach(function (k) { if (rowFor(k)) note(k, notes[k]); else delete notes[k]; });
      if (focusKey) {
        var target = focusClass ? document.querySelector('[data-cb-key^="' + V(focusKey) + ':"].' + focusClass + ', [data-line^="' + V(focusKey) + ':"].' + focusClass) : inputsFor(V(focusKey)).filter(function (i) { return i.offsetParent; })[0];
        if (target && target.focus) target.focus({ preventScroll: true });
      }
      var status = document.getElementById('cb-cart-status');
      if (status) {
        var money = window.Shopify && Shopify.formatMoney && window.wdtTheme ? Shopify.formatMoney(cart.total_price, wdtTheme.moneyFormat) : '';
        status.textContent = T.updated + ' ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + (money ? ', subtotal ' + money : '') + '.';
      }
      document.dispatchEvent(new CustomEvent('cb:cart:render', { detail: { cart: cart } }));
    });
  }

  /* ---- events (capture phase on document: the older listeners never see these) ---- */
  function stop(e) { e.stopPropagation(); }

  /* 1.19.4: a value typed in the quantity field that has not been committed yet (field still focused: no change event) is
     committed first, so leaving by a link, checkout or closing the page can never lose it. */
  function commitActiveInput() {
    var a = document.activeElement;
    if (!a || !a.matches || !a.matches(INPUT) || !inCart(a)) return;
    var key = keyOf(a);
    var raw = String(a.value).trim();
    if (key && /^\d+$/.test(raw) && parseInt(raw, 10) !== currentQty(key)) commit(key, parseInt(raw, 10), true);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN);
    if (btn && inCart(btn)) {
      var key = keyOf(btn);
      if (!key) return;
      e.preventDefault(); stop(e);
      if (btn.matches('.cart-remove-button, .main-cart-remove-button')) { commit(key, 0, true); return; }
      var base = currentQty(key);
      var next = btn.matches('.increment, .increment-btn') ? base + 1 : base - 1;
      commit(key, next, false);
      return;
    }
    var link = e.target.closest && e.target.closest('a[href]');
    if (link) commitActiveInput();
    if (link && isBusy() && !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey &&
        (!link.target || link.target === '_self') && !link.hasAttribute('download') && !link.hasAttribute('data-bs-toggle') &&
        /^https?:/i.test(link.href) && link.href.split('#')[0] !== location.href.split('#')[0]) {
      e.preventDefault(); stop(e);
      flush().then(function () { window.location.href = link.href; });
      return;
    }
    var out = e.target.closest && e.target.closest('[name="checkout"], #checkout-button, .cart__checkout-button');
    if (out) commitActiveInput();
    if (out && isBusy()) {
      e.preventDefault(); stop(e);
      flush().then(function () { window.location.href = '/checkout'; });
    }
  }, true);

  function readInput(input, andLeave) {
    var key = keyOf(input);
    if (!key) return;
    var raw = String(input.value).trim();
    if (!/^\d+$/.test(raw)) {
      input.value = currentQty(key);
      note(key, T.invalid);
      return;
    }
    commit(key, parseInt(raw, 10), true);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest(INPUT);
    if (!input || !inCart(input)) return;
    stop(e); readInput(input, true);
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    var input = t.closest && t.closest(INPUT);
    if (input && inCart(input)) {
      if (e.key === 'Enter') { e.preventDefault(); stop(e); readInput(input, false); }
      else if (e.key === 'Escape') { var k = keyOf(input); if (k) { input.value = currentQty(k); note(k, ''); } }
      return;
    }
    var btn = t.closest && t.closest(BTN);
    if (btn && inCart(btn) && (e.key === 'Enter' || e.key === ' ')) { stop(e); return; } /* the native click follows */
    var out = t.closest && t.closest('#checkout-button');
    if (out && e.key === 'Enter' && isBusy()) { e.preventDefault(); stop(e); flush().then(function () { window.location.href = '/checkout'; }); }
  }, true);

  function leave() {
    commitActiveInput();
    Object.keys(desired).forEach(function (k) {
      var body = JSON.stringify({ id: k, quantity: desired[k] });
      try { if (navigator.sendBeacon) navigator.sendBeacon(changeUrl(), new Blob([body], { type: 'application/json' })); } catch (x) {}
      try { fetch(changeUrl(), { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: body }); } catch (x) {}
      delete desired[k];
    });
    Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); delete timers[k]; });
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); });

  /* a cart line's link to its product: Shopify already puts ?variant= in item.url */
  window.cbItemUrl = function (item) {
    var url = item.url || '#';
    if (!item.variant_id || /[?&]variant=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + item.variant_id;
  };

  window.cbCart = { commit: commit, flush: flush, isBusy: isBusy };
  window.addEventListener('load', function () {
    window.updateQuantity = function (key, qty) { return commit(key, parseInt(qty, 10), true); };
    window.removeItem = function (key) { return commit(key, 0, true); };
  });
  document.addEventListener('DOMContentLoaded', function () {
    window.fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (c) { if (!pending()) syncServer(c); }).catch(function () {});
  });
})();

/*
  Clasp & Bloom 1.19.3 – (a) the page behind an open menu or drawer stays still, and the open menu lies above the service bar;
  (b) the product gallery and its thumbnail strip can be swiped with a finger.
*/
(function () {
  /* (a) The header (and the offcanvas inside it) is lifted above the service bar by CSS while html.cb-menu-open is set. The
     page is fixed in place (iOS Safari ignores overflow:hidden on the body) and put back at the same scroll position. */
  var lockY = 0, locked = 0;
  /* 1.19.12: only an offcanvas that lives INSIDE the header (menu, search) lifts the header above the service bar
     (html.cb-menu-lift). The cart drawer, filters and quick view sit outside the header with their own z-index (1300);
     lifting the header over them put it on top of their title and close button. */
  function inHeader(e) { return !!(e && e.target && e.target.closest && e.target.closest('.section-header')); }
  function lock(e) {
    if (inHeader(e)) document.documentElement.classList.add('cb-menu-lift');
    if (locked++) return;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('cb-menu-open');
    document.body.style.top = (-lockY) + 'px';
  }
  function unlock(e) {
    if (inHeader(e)) document.documentElement.classList.remove('cb-menu-lift');
    if (!locked || --locked) return;
    document.documentElement.classList.remove('cb-menu-open');
    document.documentElement.classList.remove('cb-menu-lift');
    document.body.style.top = '';
    window.scrollTo(0, lockY);
  }
  document.addEventListener('show.bs.offcanvas', lock, true);
  document.addEventListener('hidden.bs.offcanvas', unlock, true);

  /* (b) Bera creates the main gallery with allowTouchMove:false (arrows only). Swiping is switched on here; a drag of a few
     pixels starts it, so a tap still opens the zoom and vertical scrolling is not blocked (touch-action: pan-y). */
  function tuneThumbs(st, count) {
    if (!st || st.__cbTuned) return;
    st.__cbTuned = true;
    st.params.allowTouchMove = true; st.allowTouchMove = true;
    st.params.threshold = 4;
    /* 1.19.9: on touch screens the strip glides with the finger (a hard flick goes further) instead of snapping thumbnail by thumbnail */
    if (window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches && st.params.direction === 'horizontal') {
      var fm = st.params.freeMode && typeof st.params.freeMode === 'object' ? st.params.freeMode : (st.params.freeMode = {});
      fm.enabled = true; fm.sticky = false; fm.momentum = true; fm.momentumRatio = 1; fm.momentumVelocityRatio = 1; fm.momentumBounce = false; fm.minimumVelocity = 0.02;
      st.params.touchAngle = 55; /* a thumb moves in an arc: do not give up on a slightly diagonal swipe */
    }
    if (st.params.direction === 'horizontal') {
      st.params.breakpoints = {};
      var fit = function () {
        var narrow = window.innerWidth < 992;
        var many = st.slides && st.slides.length > 3;
        st.params.slidesPerView = narrow && many ? 3.4 : st.params.slidesPerView;
        st.params.spaceBetween = 10;
        st.update();
      };
      fit();
      var lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        /* 1.19.9: iOS fires 'resize' when the address bar collapses or returns while you swipe; only a real width change
           (rotation, window) refits the strip and puts the active thumbnail back in view */
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        fit(); revealActive(st, 0);
      });
    }
  }
  /* 1.19.4: the active thumbnail is always completely inside the strip. When the active photo changes (swipe, arrows, tap on a
     thumbnail, colour change, resize) the strip moves only as far as needed: forwards so that the active one is the last full
     thumbnail (the next one then peeks in from the right as a hint that more follow), backwards so that it is the first.
     Dragging the strip by hand is left alone. */
  function revealActive(st, speed) {
    if (!st || !st.slides || !st.slides.length || st.params.direction !== 'horizontal') return;
    var strip = st.el, sr = strip.getBoundingClientRect();
    var act = st.slides.filter(function (s) { return s.classList.contains('swiper-slide-thumb-active'); })[0];
    var visible = st.slides.filter(function (s) { return s.offsetParent; });
    var i = visible.indexOf(act);
    if (i < 0) return;
    var r = act.getBoundingClientRect();
    var inside = r.left >= sr.left - 0.5 && r.right <= sr.right + 0.5;
    if (inside) return;
    var full = Math.max(1, Math.floor(st.params.slidesPerView) || 1);
    var target = r.left < sr.left ? i : Math.min(i - full + 1, visible.length - 1);
    st.slideTo(Math.max(0, target), speed === undefined ? 250 : speed);
  }
  function keepThumbVisible(sg, st) {
    if (!sg || !st || st.params.direction !== 'horizontal') return;
    sg.on('slideChange', function () { revealActive(st, 250); });
    sg.on('transitionEnd', function () { revealActive(st, 250); });
  }
  /* small "3 / 7" on the main photo (phones and tablets): tells how many photos this colour has and where you are */
  function counterFor(media, sg) {
    var host = media.querySelector('.product-media-gallery');
    if (!host || !sg) return;
    var box = host;
    var el = box.querySelector('.cb-gallery-counter');
    if (!el) { el = document.createElement('div'); el.className = 'cb-gallery-counter'; el.setAttribute('aria-hidden', 'true'); box.appendChild(el); }
    var upd = function () {
      var n = sg.slides ? sg.slides.length : 0;
      el.textContent = (sg.activeIndex + 1) + ' / ' + n;
      el.hidden = n < 2;
    };
    if (!sg.__cbCounter) { sg.__cbCounter = true; sg.on('slideChange', upd); sg.on('update', upd); sg.on('transitionEnd', upd); }
    upd();
  }
  function tuneGallery(media) {
    var g = media.querySelector('.product-media-gallery');
    var t = media.querySelector('.product-thumbnails');
    var sg = g && g.swiper, st = t && t.swiper;
    if (sg && !sg.__cbTuned) {
      sg.__cbTuned = true;
      sg.params.allowTouchMove = true; sg.allowTouchMove = true;
      sg.params.threshold = 5;
      sg.params.longSwipesRatio = 0.2;
      sg.params.touchAngle = 55;
      sg.params.touchStartPreventDefault = false;
      sg.params.touchReleaseOnEdges = false;
      sg.params.simulateTouch = true;
      sg.update();
      keepThumbVisible(sg, st);
    }
    tuneThumbs(st);
    counterFor(media, sg);
    /* 1.19.9: only the first time. This runs again after every DOM change anywhere on the page (MutationObserver below), and
       moving the strip back each time undid a swipe on the strip */
    if (st && !st.__cbRevealed) { st.__cbRevealed = true; revealActive(st, 0); }
  }
  function tuneAll() {
    document.querySelectorAll('wdt-main-media').forEach(tuneGallery);
  }
  document.addEventListener('DOMContentLoaded', tuneAll);
  window.addEventListener('load', function () { tuneAll(); setTimeout(tuneAll, 600); });
  new MutationObserver(function () { clearTimeout(tuneAll._t); tuneAll._t = setTimeout(tuneAll, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* 1.19.6: dots for the style tiles (grid banner) while they are shown one at a time. The active dot follows the tile
   that is really visible (translate of the Swiper, also during the slow slide and while swiping); a tap goes to that tile. */
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function visibleIndex(sw) {
    var grid = sw.slidesGrid || [], t = -sw.translate, best = 0, d = Infinity;
    for (var i = 0; i < grid.length; i++) { var x = Math.abs(grid[i] - t); if (x < d) { d = x; best = i; } }
    return best;
  }
  function setup(wrap) {
    var dots = wrap.querySelector('.cb-tile-dots'), el = wrap.querySelector('.swiper');
    if (!dots || !el || !el.swiper || dots.__cbReady) return !!(dots && dots.__cbReady);
    var sw = el.swiper, btns = [].slice.call(dots.querySelectorAll('.cb-tile-dot'));
    if (!sw.slidesGrid || !sw.slidesGrid.length) return false;
    dots.__cbReady = true;
    function paint() {
      var n = sw.slides.length, spv = typeof sw.params.slidesPerView === 'number' ? sw.params.slidesPerView : 1;
      dots.hidden = !(n > 1 && spv < n);
      var i = visibleIndex(sw);
      btns.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    ['setTranslate', 'slideChange', 'transitionEnd', 'breakpoint', 'resize', 'update', 'touchMove', 'touchEnd'].forEach(function (ev) { sw.on(ev, paint); });
    btns.forEach(function (b, k) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        sw.slideTo(k, reduce.matches ? 0 : 600);
        paint();
      });
    });
    if (reduce.matches && sw.autoplay && sw.autoplay.running) sw.autoplay.stop();
    paint();
    return true;
  }
  function init() {
    document.querySelectorAll('.cb-tile-slider').forEach(function (w) { if (!w.__cbTries) w.__cbTries = 0; });
    var tries = 0, iv = setInterval(function () {
      var all = true;
      document.querySelectorAll('.cb-tile-slider').forEach(function (w) { if (!setup(w)) all = false; });
      if (all || ++tries > 40) clearInterval(iv);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Clasp & Bloom 1.19.8: Bundle & Save picker.
   The tiers and the button 'Add another bag' in the Bundle & Save block (cart drawer and cart page) open a list of the
   participating bags (snippet cb-bundle-progress renders it inside a <template>, only while purchasing is open).
   Choosing a colour and 'Add to cart' adds exactly that variant with the normal cart API (one request at a time);
   the discount is applied by Shopify as before. The picker sits inside the open drawer (Bootstrap keeps focus inside
   the drawer, so a picker outside it could not be used with the keyboard) or in the page. Escape or the backdrop close
   only the picker. */
(function () {
  var current = null;
  function strings(box) {
    var src = box && box.querySelector('[data-cb-bundle-i18n]');
    var o = {};
    try { o = JSON.parse(src.textContent); } catch (e) {}
    var dec = document.createElement('textarea');
    Object.keys(o).forEach(function (k) { if (typeof o[k] === 'string') { dec.innerHTML = o[k]; o[k] = dec.value; } });
    return o;
  }
  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
  }
  function closePicker() {
    if (!current) return;
    var c = current;
    current = null;
    document.removeEventListener('keydown', c.onKey, true);
    if (c.el.parentNode) c.el.parentNode.removeChild(c.el);
    document.documentElement.classList.remove('cb-picker-open');
    if (c.trigger && c.trigger.focus) { try { c.trigger.focus(); } catch (e) {} }
  }
  function openPicker(trigger) {
    var box = trigger.closest('[data-cb-bundle-progress]');
    var tpl = box && box.querySelector('template[data-cb-bundle-picker-tpl]');
    if (!tpl || current) return;
    var i18n = strings(box);
    var host = trigger.closest('.offcanvas') || document.body;
    var el = tpl.content.firstElementChild.cloneNode(true);
    el.hidden = false;
    host.appendChild(el);
    document.documentElement.classList.add('cb-picker-open');
    var panel = el.querySelector('.cb-picker__panel');
    var status = el.querySelector('[data-cb-picker-status]');
    var busy = false;
    function onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); closePicker(); return; }
      if (e.key !== 'Tab') return;
      /* the picker walks its own Tab order (WebKit otherwise jumps to the drawer's close button, outside the picker) */
      var f = focusables(el);
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      i = i < 0 ? 0 : (e.shiftKey ? (i - 1 + f.length) % f.length : (i + 1) % f.length);
      e.preventDefault();
      f[i].focus();
    }
    document.addEventListener('keydown', onKey, true);
    current = { el: el, trigger: trigger, onKey: onKey };
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-cb-picker-close]')) { closePicker(); return; }
      var colour = e.target.closest('.cb-picker__colour');
      if (colour) {
        var item = colour.closest('[data-cb-picker-item]');
        item.querySelectorAll('.cb-picker__colour').forEach(function (b) { b.setAttribute('aria-checked', b === colour ? 'true' : 'false'); });
        item.querySelector('[data-cb-picker-add]').setAttribute('data-id', colour.getAttribute('data-id'));
        item.querySelectorAll('[data-cb-picker-link]').forEach(function (a) { a.setAttribute('href', a.getAttribute('data-base') + '?variant=' + colour.getAttribute('data-id')); });
        item.querySelector('[data-cb-picker-price]').textContent = colour.getAttribute('data-price');
        var img = item.querySelector('[data-cb-picker-img]');
        if (img && colour.getAttribute('data-img')) img.src = colour.getAttribute('data-img');
        return;
      }
      var add = e.target.closest('[data-cb-picker-add]');
      if (!add || busy) return;
      busy = true;
      add.disabled = true;
      var label = add.textContent;
      add.textContent = i18n.pick_adding || 'Adding…';
      status.textContent = '';
      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(add.getAttribute('data-id')), quantity: 1 }) })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || data.message || i18n.pick_error);
            return data;
          });
        })
        .then(function () {
          var onCartPage = /\/cart\/?$/.test(location.pathname);
          if (onCartPage) { closePicker(); location.reload(); return; }
          var done = function () {
            closePicker();
            if (typeof window.showCartDrawer === 'function' && window.routes && window.routes.cart_type === 'drawer' && !document.querySelector('.cartDrawer.show')) window.showCartDrawer();
          };
          return (window.cbRefreshCart ? window.cbRefreshCart() : Promise.resolve()).then(done, done);
        })
        .catch(function (error) {
          status.textContent = (error && error.message) || i18n.pick_error || 'This bag could not be added.';
          busy = false;
          add.disabled = false;
          add.textContent = label;
        });
    });
    /* 1.19.11: say what the next bag gives: the tier reached with one more bag (Shopify still applies the discount itself) */
    var bundleMsg = el.querySelector('[data-cb-picker-bundle]');
    if (bundleMsg && i18n.pick_next) {
      var ids = (box.getAttribute('data-eligible') || '').split(',').filter(Boolean);
      var tiers = (box.getAttribute('data-tiers') || '').split(',').map(function (s) {
        var q = s.split(':');
        return { min: parseInt(q[0], 10), pct: String(q[1] || '').trim() };
      }).filter(function (x) { return x.min > 0 && parseFloat(x.pct) > 0; }).sort(function (a, b) { return a.min - b.min; });
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        if (current === null || current.el !== el) return;
        var n = 0;
        (cart.items || []).forEach(function (it) { if (ids.indexOf(String(it.product_id)) > -1) n += it.quantity; });
        var after = n + 1, hit = null;
        tiers.forEach(function (x) { if (after >= x.min) hit = x; });
        if (hit) {
          bundleMsg.textContent = i18n.pick_next.replace('__N__', after).replace('__P__', hit.pct);
        } else if (tiers.length) {
          var missing = tiers[0].min - after;
          bundleMsg.textContent = (missing === 1 ? i18n.add_one : i18n.add_other).replace('__M__', missing).replace('__P__', tiers[0].pct);
        }
        bundleMsg.hidden = !bundleMsg.textContent;
      }).catch(function () {});
    }
    var firstBtn = el.querySelector('.cb-picker__close');
    setTimeout(function () { (firstBtn || panel).focus(); }, 30);
  }
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var trigger = t.closest('[data-cb-bundle-add]') || t.closest('.cb-bundle-progress__steps');
    if (!trigger) return;
    var box = trigger.closest('[data-cb-bundle-progress]');
    if (!box || !box.querySelector('template[data-cb-bundle-picker-tpl]')) return;
    event.preventDefault();
    openPicker(trigger.matches('[data-cb-bundle-add]') ? trigger : box.querySelector('[data-cb-bundle-add]') || trigger);
  });
})();

/* Clasp & Bloom 1.19.15: footer columns collapse on phones (closed by default) and are plain open columns from 768px.
   Without this script the columns simply stay open. */
(function () {
  var phone = window.matchMedia('(max-width: 767.98px)');

  function sync(footer) {
    footer.classList.add('cb-footer--acc');
    footer.querySelectorAll('[data-cb-footer-toggle]').forEach(function (button) {
      var col = button.closest('.cb-footer__col');
      col.classList.remove('is-open');
      if (phone.matches) {
        button.disabled = false;
        button.setAttribute('aria-expanded', 'false');
      } else {
        button.disabled = true;
        button.removeAttribute('aria-expanded');
      }
    });
  }

  function init() {
    var footer = document.querySelector('.cb-footer');
    if (footer) sync(footer);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cb-footer-toggle]');
    if (!button || !phone.matches) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.closest('.cb-footer__col').classList.toggle('is-open', open);
  });
  phone.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
